import { P2, P3, Snapshots, useWindowSize } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import { getImgs } from 'utils/getters'
import styles from './Team.module.scss'

const Team = ({ team, teamText, teamImgs }) => {
  const { screenWidth } = useWindowSize()

  return (
    <div className={styles.Team}>
      <div className={styles.Header}>
        <Snapshots images={getImgs(teamImgs, 26)} imageSize={32} />
        {screenWidth > 961 ? <P2 weight="normal">{team}</P2> : <P3 weight="normal">{team}</P3>}
      </div>

      <P3 className={styles.Desc}>{teamText}</P3>
    </div>
  )
}

Team.propTypes = {
  team: PropTypes.string,
  teamText: PropTypes.string,
  teamImgs: PropTypes.arrayOf(PropTypes.string)
}

Team.defaultProps = {
  team: '',
  teamText: '',
  teamImgs: []
}

export default Team
